module.exports = "/assets/data/b0233f924e4779b15579080fe1c55b39-NE62.data.json";